export default __webpack_public_path__ + "static/media/ECE-graf-PLA-FIX-2-cat--1.ace361fc.png";